import React, {Component} from 'react';

import {ClientReportsContent} from "./ClientReportsContent";
import {withRouterParams} from "../../utils/withRouterParams";

export class ClientReports extends Component {
    render() {
        return (
            <ClientReportsContent clientId={this.props.match.params.id}/>
        )
    }
}

export default withRouterParams(ClientReports);
